<template>
  <div class="title">
    <div
      :id="!CheckCN()?'title__rank_One':''"
      class="title__rank"
      :class="selectItem === 0 ? 'title__checked' : ''"
      @click="select(0)"
    >
      {{TLang('综合排序','my')}}
    </div>
    <div
      :id="!CheckCN()?'title__rank_One':''"
      class="title__rank lastest"
      :class="selectItem === 2 ? 'title__checked' : ''"
      @click="select(2)"
    >
      {{TLang('最近开场','my')}}
    </div>
    <div
      class="title__price"
      :class="selectItem === 1 ? 'title__checked' : ''"
      @click="select(1)"
    >
      <div>{{TLang('价格','home')}}</div>
      <i
        class="title__top"
        :class="orderBy === 1 ? 'title__top_select' : ''"
      ></i>
      <i
        class="title__bot"
        :class="orderBy === 0 ? 'title__bot_select' : ''"
      ></i>
    </div>
    <div
      :class="isInprice ? 'title__price-edit inPrice' : 'title__price-edit'"
      @mouseover="inPrice"
      @mouseleave="outPrice"
    >
      <!-- 英文版 -->
      <div class="title__price-inner" v-if="!CheckCN()">
        <input
          
          class="title__price-inp"
          v-model="minPriceIn"
          placeholder="Min.price"
        /><span class="title__line">-</span
        >
        <input
          class="title__price-inp"
          v-model="maxPriceIn"
          placeholder="Max.price"
        /><span class="title-price-btn btn-sure" @click="sureBtn">{{TLang('确定','home')}}</span
        ><span class="title-price-btn title-price-cancel-btn" @click="cancelBtn"
          >{{TLang('清空','list')}}</span
        >
      </div>
      <!-- 中文版 -->
      <div class="title__price-inner" v-if="!CheckCN()">
        <input
          
          class="title__price-inp"
          v-model="minPriceIn"
          placeholder="最低价"
        /><span class="title__line">-</span
        >
        <input
          class="title__price-inp"
          v-model="maxPriceIn"
          placeholder="最高价"
        /><span class="title-price-btn btn-sure" @click="sureBtn">{{TLang('确定','home')}}</span
        ><span class="title-price-btn title-price-cancel-btn" @click="cancelBtn"
          >{{TLang('清空','list')}}</span
        >
      </div>
    </div>
    <div class="title__count">
      {{TLang('共','list')}}<span class="title__number">{{ total }}</span
      >{{TLang('场演出','list')}}
    </div>
  </div>
</template>

<script>
import { getCookie } from "@/utils";
export default {
  name: "packagelisttitle",
  props: {
    total: Number,
    minPrice: [String, Number],
    maxPrice: [String, Number]
  },
  data() {
    return {
      selectItem: 0, // 选项 0 为综合排序 1 为 价格，2为最近开场
      orderBy: null, // 默认由高到低  0是由高到低 1 是由低到高
      checkedPrice: "",
      isInprice: false,
      minPriceIn: this.minPrice,
      maxPriceIn: this.maxPrice,
      CookiesOne: getCookie('df_lang'),
    };
  },
  watch: {
    minPrice(val) {
      this.minPriceIn = val;
    },
    maxPrice(val) {
      this.maxPriceIn = val;
    }
  },
  methods: {
    select(index) {
      if (index !== this.selectItem) {
        // 判断是否第二次点击来判断当前点击得是不是价格
        this.selectItem = index;
        if (index == 0 || index == 2) {
          this.orderBy = null;
        } else {
          this.orderBy = 1;
        }
        this.$emit("changetitleselect", this.selectItem);
      } else if (index === this.selectItem && index == 1) {
        let sortType;
        if (this.orderBy == 1) {
          this.orderBy = 0;
          sortType = 3; // 从高往低
        } else {
          this.orderBy = 1;
          sortType = 1; // 从低往高
        }
        this.$emit("changetitleselect", sortType);
      }
    },
    inPrice() {
      this.isInprice = true;
    },
    outPrice() {
      this.isInprice = false;
    },
    sureBtn() {
      if (
        Number(this.minPriceIn) > Number(this.maxPriceIn) &&
        this.minPriceIn != "" &&
        this.maxPriceIn != ""
      ) {
        let middle = this.minPriceIn;
        this.minPriceIn = this.maxPriceIn;
        this.maxPriceIn = middle;
      }
      this.$emit("changePrice", {
        minPrice: this.minPriceIn,
        maxPrice: this.maxPriceIn
      });
    },
    cancelBtn() {
      this.minPriceIn = "";
      this.maxPriceIn = "";
      this.$emit("changePrice", {
        minPrice: this.minPriceIn,
        maxPrice: this.maxPriceIn
      });
    }
  }
};
</script>

<style lang="less" scoped>
input:focus::-webkit-input-placeholder {
  color: transparent;
  /* transparent是全透明黑色(black)的速记法，即一个类似rgba(0,0,0,0)这样的值 */
}
.title {
  margin-top: 24px;
  width: 914px;
  font-size: 14px;
  height: 48px;
  border: 1px solid rgba(229, 229, 229, 1);
  // background: rgba(247, 247, 247, 1);
  background: #fafafa;
  .clearfix;
}
input::-webkit-input-placeholder {
  color: #cbcdce;
}
.title__rank {
  height: 46px;
  line-height: 46px;
  width: 104px;
  text-align: center;
  // border-right: 1px solid #e5e5e5;
  border-right: 1px solid #e0e6ed;
  cursor: pointer;
  float: left;
}
.lastest {
  width: 80px;
}
.title__rank:hover {
  color: @color-main;
}
.title__price {
  height: 46px;
  line-height: 46px;
  width: 64px;
  // text-align: center;
  text-indent: 12px;
  // border-right: 1px solid #e5e5e5;
  border-right: 1px solid #e0e6ed;
  font-size: 14px;
  cursor: pointer;
  float: left;
  position: relative;
}
.title__price:hover {
  color: @color-main;
}
.title__top {
  display: inline-block;
  width: 0;
  height: 0;
  border-top: 5px solid transparent;
  border-left: 5px solid transparent;
  border-bottom: 5px solid #cccccc;
  border-right: 5px solid transparent;
  position: absolute;
  top: 11px;
  right: 11px;
}
.title__top_select {
  border-bottom: 5px solid @color-main;
}
.title__number {
  font-weight: bold;
}
.title__bot {
  display: inline-block;
  width: 0;
  height: 0;
  border-top: 5px solid #ccc;
  border-left: 5px solid transparent;
  border-bottom: 5px solid transparent;
  border-right: 5px solid transparent;
  position: absolute;
  bottom: 12px;
  right: 11px;
}
.title__bot_select {
  border-top: 5px solid @color-main;
}
.title__checked {
  background-color: white;
  color: @color-main;
}
.title__count {
  float: right;
  line-height: 46px;
  margin-right: 20px;
  // color: #7f7f7f;
  color: #b2b2b2;
  font-size: 12px;
}
.title__price-edit {
  // width: 302px;
  width: 193px;
  overflow: hidden;
  float: left;
  height: 46px;
  border-right: 1px solid rgba(229, 229, 229, 1);
  transition: all 0.3s ease-in-out;
}
.title__price-inner {
  width: 305px;
  padding: 0 10px;
}
.title__price-inp {
  width: 78px;
  height: 28px;
  border: 1px solid rgba(229, 229, 229, 1);
  display: inline-block;
  text-align: center;
  padding: 6px;
  font-size: 12px;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
}
.title__price-inp:focus {
  border: 1px solid rgba(61, 150, 226, 1);
}
.title__line {
  color: #d5d8db;
  margin: 0 5px;
  line-height: 46px;
}
.title-price-btn {
  width: 48px;
  height: auto;
  background: #3d96e2;
  border-radius: 2px;
  margin: 6px 0px;
  font-size: 12px;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 24px;
  display: inline-block;
  text-align: center;
  cursor: pointer;
}
.btn-sure {
  margin: 0 5px 0 11px;
}
.title-price-cancel-btn {
  background: #ffffff;
  color: rgba(153, 153, 153, 1);
  border: 1px solid rgba(229, 229, 229, 1);
}
.inPrice {
  background: #ffffff;
  width: 305px;
}
#title__rank_One{
     line-height: 20px;
     padding-top: 5px;
}
</style>
